// Customer admin API wrappers (calls /api/admin/customers).

import { deleteData, getData, patchData, postData } from '../../lib/api-client';

export interface Customer {
  id: string;
  name: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  companyTaxId: string | null;
  notes: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CustomerListQuery {
  page?: number;
  limit?: number;
  search?: string;
  sort?: string;
}

export interface CustomerListResponse {
  data: Customer[];
  meta: { total: number; page: number; limit: number };
}

export interface CreateCustomerInput {
  name: string;
  contactName: string;
  contactEmail: string;
  contactPhone?: string;
  companyTaxId?: string | null;
  notes?: string;
  isActive?: boolean;
}

export type UpdateCustomerInput = Partial<CreateCustomerInput>;

export function listCustomers(query: CustomerListQuery): Promise<CustomerListResponse> {
  return getData<CustomerListResponse>('/admin/customers', { params: query });
}

export function createCustomer(input: CreateCustomerInput): Promise<{ data: Customer }> {
  return postData('/admin/customers', input);
}

export function updateCustomer(id: string, input: UpdateCustomerInput): Promise<{ data: Customer }> {
  return patchData(`/admin/customers/${id}`, input);
}

export function deleteCustomer(id: string): Promise<void> {
  return deleteData(`/admin/customers/${id}`);
}
